import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import SettingsLayout from './SettingsLayout'
import createSettingsComponents from './SettingsComponentDefinition'
import SettingsStore from './SettingStore'
import settingComponents from './SettingsComponents'
import '../../assets/css/edit.css'
import SettingsForm from './SettingsForm'
import DeleteModal from '../../UniformComponents/DeleteModal'
import ConfirmationModal from '../../UniformComponents/ConfirmationModal'
import PublishConfirmationModal from '../Survey/Modals/PublishConfirmationModal'
import ReOpenSurvey from '../Survey/Modals/ReOpenSurvey'
import LanguageWarning from '../Survey/Modals/LanguageWarning'

@observer
class Settings extends Component {
    constructor(props) {
        super(props)
        const { store, isTemplate } = this.props
        const { survey } = store
        console.log('SURVEY', survey)
        const surveyType = R.pathOr(undefined, ['metadata', 'taxonomy', 'surveyType'], survey)
        this.settingsStore = new SettingsStore(props)
        this.surveyType = surveyType
        this.isTemplate = isTemplate
    }

    componentDidMount() {
        this.settingsStore.addValidators()
        this.settingsStore.initStore()
    }

    componentWillUnmount() {
        this.settingsStore.removeValidators()
    }

    renderTab = (tab) => {
        const { store } = this.props
        let settingsFields = []
        settingsFields = createSettingsComponents(
            this.settingsStore,
            tab,
            store,
            settingComponents,
            this.isTemplate,
        )
        return settingsFields
    }

    renderElements = (settingsFields) => (
        <div className="select-row">
            <SettingsForm
                store={this.settingsStore}
                formFields={settingsFields}
            />
        </div>
    )

    renderSettingsPanel = () => {
        const { store } = this.props
        const { survey } = store
        const { metadata } = survey
        const { industrySpecificInfo } = metadata.productInfo
        const { industry } = industrySpecificInfo
        const { taxonomy } = metadata
        const { surveyType } = taxonomy
        let switchType
        if (industry === 'EV') {
            switchType = industry
        } else {
            switchType = surveyType === 'PE' ? 'CEandPE' : 'EM'
        }
        this.settingsStore.componentObject = this.renderTab(switchType)
    }

    handleClosePublishModal = () => { this.showPublishModal = false }

    render() {
        this.renderSettingsPanel()
        const {
            surveyName,
            dataLoading,
            deleteModalOpen,
            onDeleteSurvey,
            deleteModalHide,
            isOpenSurveyModalOpen,
            isConfirmSurveyCloseOpen,
            toggleOpenSurveyModal,
            onDateChange,
        } = this.settingsStore
        const { store } = this.props
        const { timeZone } = store
        return (
            <Fragment>
                {(dataLoading) ? <div className="overlay"><div className="loader" /></div> : null }
                <SettingsLayout
                    pageTitle={this.surveyType === 'EM' ? 'Languages' : 'Survey languages'}
                    renderSettings={this.renderElements}
                    store={this.settingsStore}
                    settings={this.settingsStore.componentObject}
                    upperPanelTitle={this.surveyType !== 'EM' ? i18n.t('s_edit_page_title', 'Survey settings') : i18n.t('settings_right_panel_title_EM', 'Settings')}
                    isTemplate={this.isTemplate}
                />
                {deleteModalOpen && (
                    <DeleteModal
                        show={deleteModalOpen}
                        onClose={deleteModalHide}
                        onDelete={onDeleteSurvey}
                        headerText={i18n.t('settings_delete_header', 'Delete Survey')}
                        content={`${i18n.t('settings_delete_content', 'Are you sure you want to delete survey:')} ${surveyName}`}
                        cssClass="delete-modal-buttons"
                        noLabel={i18n.t('settings_delete_return', 'No - return to page')}
                        yesLabel={i18n.t('settings_delete_delete_button', 'Yes - Delete Survey')}
                    />
                )}
                {isOpenSurveyModalOpen && (
                    <ReOpenSurvey
                        show={isOpenSurveyModalOpen}
                        tz={timeZone}
                        onDateChange={onDateChange}
                        onClose={() => toggleOpenSurveyModal(false)}
                    />
                )}
                <ConfirmationModal
                    show={isConfirmSurveyCloseOpen}
                    onClose={this.settingsStore.revertSurveyCloseDate}
                    onFalse={this.settingsStore.revertSurveyCloseDate}
                    onTrue={this.settingsStore.confirmClose}
                    description={i18n.t('settings_confirm_close_content')}
                    title={i18n.t('gen_confirm_popup_title')}
                />
                <LanguageWarning
                    show={this.settingsStore.showLocaleWarning}
                    onHide={() => { this.settingsStore.showLocaleWarning = false }}
                />

                <PublishConfirmationModal
                    store={store}
                    show={this.settingsStore.showPublishConfirmationModal}
                    handleClose={this.settingsStore.handleClosePublishmodal}
                />
            </Fragment>

        )
    }
}
export default Settings
